const groupLinks = {
  details: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/groups/${namespace}/${groupId}`,

  overview: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/groups/${namespace}/${groupId}/overview`,

  sharing: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/groups/${namespace}/${groupId}/sharing`,

  settings: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/groups/${namespace}/${groupId}/settings`,

  contents: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/groups/${namespace}/${groupId}/contents`,

  metadata: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/groups/${namespace}/${groupId}/metadata`,

  activity: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/groups/${namespace}/${groupId}/activity`,
};

export default groupLinks;
